<template>
  <span>{{ $moment2text($text2moment(value), 'DD/MM/YYYY HH:mm:ss') }}</span>
</template>
<script>
import BaseColumnRendererMixin from 'vue-cl/renderers/column/BaseColumnRendererMixin';
import MomentUtilsMixin from 'vue-core/mixins/MomentUtilsMixin';

export default {
  mixins: [ BaseColumnRendererMixin, MomentUtilsMixin ]
};
</script>
